module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-11-f7dd6b8f2eed3d37465eed20cc6fc3dd.jpg";